import { LoggerFactory } from "../logger";

const log = LoggerFactory.create(`EventManager`);

export class EventManager {
  private handlers: { [type: string]: Function[] };

  public constructor() {
    this.handlers = {};
  }

  public on(type: string, fn: Function): void {
    log.debug("addEventListener", type, fn);
    this.initHandler(type);
    this.handlers[type].push(fn);
  }

  public once(type: string, fn: Function) {
    log.debug("once()", type);

    this.initHandler(type);

    const onceCallback = (...args: any) => {
      fn.apply(null, args);

      this.off(type, onceCallback);
    };

    this.on(type, onceCallback);
  }

  public off(type: string, fn?: Function) {
    log.debug("off()", arguments);

    let idx;

    this.initHandler(type);

    if (!fn) {
      delete this.handlers[type];
      return;
    }

    idx = this.handlers[type].indexOf(fn);

    if (idx !== -1) {
      this.handlers[type].splice(idx, 1);
    }
  }

  public trigger(type: string, args?: any[]): void {
    const debugArgs = args ? args : [];
    log.debug("trigger", type, ...debugArgs);

    if (this.handlers[type]) {
      this.handlers[type].forEach(fn => {
        fn(args);
      });
    }
  }

  private initHandler(type: string): void {
    if (!this.handlers[type]) {
      this.handlers[type] = [];
    }
  }
}
